export function handleTeamDetailsImageError(teamIconRef) {
    const imageElement = teamIconRef.current;
    if (imageElement) {
        imageElement.style.visibility = "hidden";
    }
}
//# sourceMappingURL=handleTeamDetailsImageError.js.map